<template>
  <div>
    <b-row class="font-weight-bold">
      <b-col cols="3">
        Ürün No
      </b-col>
      <b-col cols="4">
        Ürün Barkod
      </b-col>
      <b-col cols="3">
        Kat Sayı
      </b-col>
      <b-col cols="2" />
    </b-row>
    <b-row
      v-for="(subProduct,index) in subProducts"
      :key="index"
      style="margin-top: 1px"
    >
      <b-col
        cols="3"
        class="pl-0 pr-0"
      >
        <b-form-input
          v-model="subProduct.sub_product_id"
          type="number"
          size="sm"
          @input="onSubProductIdInput(subProduct)"
        />
      </b-col>
      <b-col
        cols="4"
        class="pl-0 pr-0"
      >
        <b-form-input
          v-model="subProduct.barcode"
          type="number"
          size="sm"
          @input="onBarcodeInput(subProduct)"
        />
      </b-col>
      <b-col
        cols="3"
        class="pl-0 pr-0"
      >
        <b-form-input
          v-model="subProduct.multiple"
          type="number"
          size="sm"
        />
      </b-col>
      <b-col
        cols="2"
        class="pl-0 pr-0"
      >
        <b-button
          size="sm"
          :disabled="subProducts.length<2"
          variant="danger"
          @click="delRow(index)"
        >
          <feather-icon icon="XCircleIcon" />
        </b-button>
      </b-col>
    </b-row>
    <b-row style="margin-top: 3px">
      <b-col cols="12">
        <b-button-group size="sm">
          <b-button
            variant="primary"
            @click="addRow"
          >
            Satır Ekle
          </b-button>
          <b-button
            variant="success"
            @click="saveBundleProduct"
          >
            Ürünü Kaydet
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import axios from '@/libs/axios'

export default {
  name: 'ProductSubProducts',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    subProducts: [{ sub_product_id: null, barcode: null, multiple: 1 }],
  }),
  mounted() {
    const productId = this.$route.query.product_id
    if (productId && Number.isInteger(Number(productId))) {
      this.subProducts[0].sub_product_id = Number(productId)
    }
  },
  methods: {
    addRow() {
      this.subProducts.push({ sub_product_id: null, barcode: null, multiple: 1 })
    },
    onSubProductIdInput(subProduct) {
      if (subProduct.sub_product_id) {
        subProduct.barcode = null
      }
    },
    onBarcodeInput(subProduct) {
      if (subProduct.barcode) {
        subProduct.sub_product_id = null
      }
    },
    delRow(index) {
      this.subProducts.splice(index, 1)
    },
    saveBundleProduct() {
      if (this.subProducts.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hata ! ',
            text: 'En az bir alt ürün eklemelisiniz.',
            variant: 'danger',
            icon: 'XCircleIcon',
          },
        })
        return
      }

      const params = []
      for (let i = 0; i < this.subProducts.length; i++) {
        const item = this.subProducts[i]
        const rowNum = i + 1
        if ((!item.sub_product_id && !item.barcode) || !item.multiple || isNaN(item.multiple) || Number(item.multiple) <= 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hata ! ',
              text: `${rowNum}. satır: veriler eksik olamaz`,
              variant: 'danger',
              icon: 'XCircleIcon',
            },
          })
          return
        }
        params.push({ sub_product_id: item.sub_product_id, barcode: item.barcode, multiple: item.multiple })
      }

      const ids = params.map(param => Number(param.sub_product_id))
      const barcodes = params.map(param => String(param.barcode || '').trim()).filter(barcode => barcode !== '')

      if (new Set(ids).size !== ids.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hata ! ',
            text: 'Aynı sub_product_id birden fazla kez eklenemez.',
            variant: 'danger',
            icon: 'XCircleIcon',
          },
        })
        return
      }

      if (new Set(barcodes).size !== barcodes.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hata ! ',
            text: 'Aynı barcode birden fazla kez eklenemez.',
            variant: 'danger',
            icon: 'XCircleIcon',
          },
        })
        return
      }

      if (params.some(param => param.sub_product_id && String(param.barcode || '').trim())) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hata ! ',
            text: 'Aynı satırda hem sub_product_id hem barcode birlikte girilemez.',
            variant: 'danger',
            icon: 'XCircleIcon',
          },
        })
        return
      }

      if (this.subProducts.length === 1 && this.subProducts[0].multiple == 1) {
        this.$store.dispatch('product/addTyMatchingProduct', {
          productId: this.subProducts[0].sub_product_id,
          productBarcode: this.subProducts[0].barcode,
          sku: this.product.merchant_sku,
        })
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                text: 'Başarılı',
                variant: 'success',
              },
            })
          })
      } else {
        let payload = {
          ty_product_id: this.product.id,
          ty_product_name: this.product.product_name,
          ty_product_barcode: this.product.merchant_sku,
          ty_product_image: this.product.images && this.product.images[0] ? this.product.images[0].url : '',
          product_products: this.subProducts,
        }
        axios.post('/product/subproduct/create-new-bundle-product', payload)
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: {
                text: res.data.message,
                variant: res.data.status,
              },
            })
          })
          .catch(() => {
            alert('Hata Oldu')
          })
      }
    },
  },
}
</script>
